import api from '../../services/api';
import { Cuota } from '../cuentacorriente/ctaCorrienteAPI';

export interface Plan {
  nro_plan: string;
  cant_cuotas: string;
  recurso: string;
  plan: string;
  cuotas: CuotaPlan[];
  estado: string;
  descripcion: string;
}

export interface CuotaPlan {
  estado: string;
  cuota: string;
  tipo_comprob: string;
  nro_comprob: string;
  fecha_vto: string;
  anio_vto: string;
  fecha_pago_txt: null;
  fecha_pago: null;
  monto: string;
  monto_capital: string;
  situacion_cc: string;
  orden_cc: string;
  recargo: string;
  multa: string;
  total: string;
}

export interface PlanData {
  tipo: string;
  id: string;
  recurso: string;
}

export interface CreatedPlans {
  limite_cant_cuotas: number;
  minimo_cant_cuotas: number;
  int_fin: number;
  anio_ini_incl: number;
  anio_fin_incl: number;
  periodos: string[];
  id: string;
  porc_dto_interes: string;
}

export interface VistaPreviaCuota {
  usuario: string
  cuota: string
  monto: string
  fecha_vto: string
  monto_capital: string
  monto_interes: string
  cuotas_propuesta: string
  idsesion: string
  idconsulta: string
  orden: any
  descripcion: any
  monto_int_cuota: any
  estado: any
  fecha_cobranza: any
  estado_descr: any
  nro_plan: any
  tipo_comprob: any
  nro_comprob: any
  marcado: any
  monto_multa: any
  cc_estado: any
  cc_situacion: any
}

async function getPlanesByResource(data: PlanData) {
  const { tipo, id, recurso } = data;

  const response = await api<Plan[]>('GET', `imponibles/${tipo}-${id}/${recurso}/planes`);

  return response;
}

export interface DataPayload {
  selectedCuotas: Cuota[];
  resourceNumber: string;
}

async function getPlanesByPeriod(data: DataPayload) {
  const { selectedCuotas, resourceNumber } = data;

  const url = selectedCuotas
    .map(function(da) {
      return ('0' + da.cuota).slice(-2) + '/' + da.anio;
    })
    .join(',');

  const response = await api<CreatedPlans[]>('GET', `recursos/${resourceNumber}/planes?periodos=${url}`);

  return response;
}

export interface RegisterPlanPayload {
  tipo: string;
  id: string;
  recurso: string;
  cuotas: string;
  planId: string;
}

async function registerPlan(data: RegisterPlanPayload) {
  const { tipo, id, recurso, cuotas, planId } = data;

  const payload = {
    propuesta: planId,
    cuotas: cuotas,
  };

  const response = await api<CreatedPlans[]>('POST', `imponibles/${tipo}-${id}/${recurso}/planes`, payload);

  return response;
}

async function getPlanPdf(data: RegisterPlanPayload) {
  const { tipo, id, recurso } = data;

  const response = await api<CreatedPlans[]>('GET', `pdf/propuesta/${tipo}-${id}/${recurso}`);

  return response;
}

export interface VistaPreviaPlanes {
  [key: string]: VistaPreviaCuota[];
}

export interface GetPlanPreviewData {
  tipo: string;
  id: string;
  recurso: string;
  propuesta: string;
  cuotas: number[];
}

async function getPlanPreview(data: GetPlanPreviewData) {
  const { tipo, id, recurso, propuesta, cuotas } = data;

  const response = await api<VistaPreviaPlanes>('POST', `imponibles/${tipo}-${id}/${recurso}/planes/preview`, {
    propuesta,
    cuotas,
  });

  return response;
}

const planesAPI = {
  getPlanesByResource,
  getPlanesByPeriod,
  registerPlan,
  getPlanPdf,
  getPlanPreview,
};

export default planesAPI;
